import { render, staticRenderFns } from "./compreSchoolArea.vue?vue&type=template&id=0e3ac7a5&scoped=true&"
import script from "./compreSchoolArea.vue?vue&type=script&lang=js&"
export * from "./compreSchoolArea.vue?vue&type=script&lang=js&"
import style0 from "./compreSchoolArea.vue?vue&type=style&index=0&id=0e3ac7a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3ac7a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
